/* `auto` keeps the intrinsic ratio once metadata arrives and falls back to 16/9
   before it does, so the dialog does not resize under the talent mid-load.
   Portrait recordings letterbox rather than overflow. */
.video {
  display: block;
  inline-size: 100%;
  max-block-size: 60vh;
  aspect-ratio: auto 16 / 9;
  object-fit: contain;
  background: var(--grey-900);
  border-radius: var(--shape-md);
}
